import React, { Component, createRef } from "react";

import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { addUnitAPI, getOrganizatioanApi, updateUnitAPI } from "api";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

class AddExternalUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      factoryType: "1",
      organizations: {},
      id: props?.location?.query ? props?.location?.query?.data.id : "",
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: false, isView: false, data: null },
    };
    this.filesharhe_ref = createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    const data = await getOrganizatioanApi();
    if(data && data.data){
      this.setState({
        organizations: data.data.organizations[0],
      });
    }
    

    if (this.state.props.isEdit == true)
      this.setState({
        factoryType: this.state.props.data.factoryType.toString(),
      });
    if (this.state.props.isView == true)
      this.setState({
        factoryType: this.state.props.data.factoryType.toString(),
      });
  }

  handleSubmit = async (e, values) => {
    e.preventDefault();
    if (this.state.props.isEdit == false) {
      const data = await addUnitAPI(values);
      if (data && data.success) {
        this.setState({
          id: data.data.id,
        });
      }
    } else {
      delete values.createdAt;
      delete values.updatedAt;
      const data = await updateUnitAPI(values);
      if (data && data.success) {
        this.setState({
          id: data.data.id,
        });
      }
    }
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title = "manage organization";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Manage Factory")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <h4 className="pb-3 text-black fw-bold">
                      {this.state.props.isEdit == false
                        ? `${this.props.t("Add Factory(Unit)")}`
                        : this.state.props.isView == true
                        ? `${this.props.t("View Factory(Unit)")}`
                        : `${this.props.t("Edit Factory(Unit)")}`}
                    </h4>
                    {this.state.factoryType !== "2" && (
                      <Formik
                        enableReinitialize={true}
                        initialValues={
                          this.state.props.data == null
                            ? {
                                name: "",
                                factoryType: "1",
                                addressLine1: "",
                                addressLine2: "",
                              }
                            : this.state.props.data
                        }
                        validationSchema={Yup.object().shape({
                          attachment: Yup.mixed()
                            .nullable()
                            .notRequired()
                            .test(
                              "FILE_SIZE",
                              "Uploaded file is too big.",
                              value =>
                                !value || (value && value.size <= FILE_SIZE)
                            )
                            .test(
                              "FILE_FORMAT",
                              "Uploaded file has unsupported format.",
                              value =>
                                !value ||
                                (value &&
                                  SUPPORTED_FORMATS.includes(value.type))
                            ),
                          name: Yup.string().required(
                            "Please Enter Your factory Name"
                          ),
                          factoryType: Yup.string()
                            .min(1)
                            .max(255)
                            .required("This value is required"),
                          addressLine1: Yup.string()
                            .min(1)
                            .max(255)
                            .required("Please Enter Your Address"),
                          addressLine2: Yup.string()
                            .min(1)
                            .max(255)
                            .nullable()
                            .notRequired(),
                        })}
                        onSubmit={async (values, formikHelpers) => {}}
                      >
                        {({ errors, status, touched, values, isValid }) => (
                          <Form className="needs-validation">
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="factoryType"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Factory(Unit) Type")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    onChange={e =>
                                      this.setState({
                                        factoryType: e.target.value,
                                      })
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    value={this.state.factoryType}
                                    className={
                                      `form-control ${this.state.props.isView == true ? "" : "form-select"} fs-5` +
                                      (errors.factoryType && touched.factoryType
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name="factoryType"
                                    as="select"
                                  >
                                    <option value="" disabled>
                                      select
                                    </option>
                                    <option value="1">Internal</option>
                                    <option value="2">External</option>
                                  </Field>
                                  <ErrorMessage
                                    name="factoryType"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="name"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Factory(Unit) Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.name && touched.name
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    type="text"
                                    name="name"
                                    placeholder="Enter your party name"
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="addressLine1"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 1")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.addressLine1 &&
                                      touched.addressLine1
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    type="text"
                                    name="addressLine1"
                                    placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                  />
                                  <ErrorMessage
                                    name="addressLine1"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="addressLine2"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 2")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.addressLine2 &&
                                      touched.addressLine2
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    type="text"
                                    name="addressLine2"
                                    placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                  />
                                  <ErrorMessage
                                    name="addressLine2"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="col-md-12 text-end">
                                {this.state.props.isView ? (
                                  <Link to="/organization-partyList">
                                    <Button
                                      color="primary"
                                      className="fs-4 px-5"
                                    >
                                      Back
                                    </Button>
                                  </Link>
                                ) : (
                                  <Button
                                    color="primary"
                                    className="fs-4 px-5"
                                    type="submit"
                                    onClick={() => {
                                      if (this.state.props.isEdit == false) {
                                        if (isValid) {
                                          this.handleSubmit(event, values);
                                        } else {
                                        }
                                      } else {
                                        this.handleSubmit(event, values);
                                      }
                                    }}
                                  >
                                    Submit
                                  </Button>
                                )}
                              </div>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    )}

                    {this.state.factoryType === "2" && (
                      <Formik
                        enableReinitialize={true}
                        initialValues={
                          this.state.props.data == null
                            ? {
                                name: "",
                                factoryType: "2",
                                addressLine1: "",
                                addressLine2: "",
                                id: "",
                                companyName: "",
                                gstNo: "",
                                panNo: "",
                                cinLlpIn: "",
                                tdsRate: "",
                                city: "",
                                state: "",
                                zipCode: "",
                                cvdRate: "",
                                lphtRate: "",
                                realRate: "",
                                jiramRate: "",
                                mobileNo1: "",
                                mobileNo2: "",
                                email: "",
                                shortName: "",
                                since: "",
                                tagLine: "",
                                adminNotes: "",
                              }
                            : this.state.props.data
                        }
                        validationSchema={Yup.object().shape({
                          attachment: Yup.mixed()
                            .nullable()
                            .notRequired()
                            .test(
                              "FILE_SIZE",
                              "Uploaded file is too big.",
                              value =>
                                !value || (value && value.size <= FILE_SIZE)
                            )
                            .test(
                              "FILE_FORMAT",
                              "Uploaded file has unsupported format.",
                              value =>
                                !value ||
                                (value &&
                                  SUPPORTED_FORMATS.includes(value.type))
                            ),
                          name: Yup.string()
                            .min(1)
                            .max(255)
                            .required("Please Enter Your factory Name"),
                          factoryType: Yup.string()
                            .min(1)
                            .max(255)
                            .required("This value is required"),
                          addressLine1: Yup.string()
                            .min(1)
                            .max(255)
                            .required("Please Enter Your Address"),
                          addressLine2: Yup.string()
                            .min(1)
                            .max(255)
                            .nullable()
                            .notRequired(),
                          id: Yup.string().notRequired(),
                          companyName: Yup.string()
                            .min(1)
                            .max(255)
                            .required(
                              "Please Enter Your {this.props.t('Party Name')}"
                            ),
                          gstNo: Yup.string()
                            .min(0)
                            .max(255)
                            .required("Please Enter Your GST number"),
                          panNo: Yup.string()
                            .min(1)
                            .max(255)
                            .required("Please Enter Your PAN number"),
                          cinLlpIn: Yup.string()
                            .min(1)
                            .max(255)
                            .required("Please Enter Your CIN/LLP number"),
                          tdsRate: Yup.number()
                            .min(1)
                            .max(32767)
                            .required("Please Enter Your TDSRate rate"),
                          city: Yup.string()
                            .min(1)
                            .max(255)
                            .required("Please Enter Your city"),
                          state: Yup.string()
                            .min(1)
                            .max(32767)
                            .required("Please Enter Your state"),
                          zipCode: Yup.number()
                            .min(1)
                            .max(999999)
                            .nullable()
                            .notRequired(),
                          cvdRate: Yup.number()
                            .min(1)
                            .max(this.state.organizations.cvdRate)
                            .required("Please Enter CVD Rate"),
                          lphtRate: Yup.number()
                            .min(1)
                            .max(this.state.organizations.lphtRate)
                            .required("Please Enter LPHT rate"),
                          realRate: Yup.number()
                            .min(1)
                            .max(this.state.organizations.realRate)
                            .required("Please Enter REAL rate"),
                          jiramRate: Yup.number()
                            .min(1)
                            .max(this.state.organizations.jiramRate)
                            .required("Please Enter JIRAM rate"),
                          mobileNo1: Yup.number()
                            .min(1111111111)
                            .max(9999999999)
                            .required("Please Enter Your Mobile Number"),
                          mobileNo2: Yup.number()
                            .min(1111111111)
                            .max(9999999999)
                            .notRequired(),
                          email: Yup.string()
                            .min(1)
                            .max(50)
                            .required("Please Enter Your email"),
                          shortName: Yup.string()
                            .min(1)
                            .max(10)
                            .required("Please Enter Your Short Name"),
                          since: Yup.number()
                            .min(1111)
                            .max(9999)
                            .required("This value is required"),
                          tagLine: Yup.string()
                            .min(1)
                            .max(255)
                            .required("This value is required"),
                          adminNotes: Yup.string()
                            .min(1)
                            .max(255)
                            .required("This value is required"),
                        })}
                        onSubmit={async (values, formikHelpers) => {}}
                      >
                        {({ errors, status, touched, values, isValid }) => (
                          <Form className="needs-validation">
                            <Row>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="factoryType"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Factory(Unit) Type")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    onChange={e =>
                                      this.setState({
                                        factoryType: e.target.value,
                                      })
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    value={this.state.factoryType}
                                    className={
                                      `form-control ${this.state.props.isView == true ? "" : "form-select"} fs-5` +
                                      (errors.factoryType && touched.factoryType
                                        ? " is-invalid"
                                        : "")
                                    }
                                    name="factoryType"
                                    as="select"
                                  >
                                    <option value="" disabled>
                                      select
                                    </option>
                                    <option value="1">Internal</option>
                                    <option value="2">External</option>
                                  </Field>
                                  <ErrorMessage
                                    name="factoryType"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="name"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                    {this.props.t("Factory(Unit) Name")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.name && touched.name
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    type="text"
                                    name="name"
                                    placeholder="Enter your party name"
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="addressLine1"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 1")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.addressLine1 &&
                                      touched.addressLine1
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    type="text"
                                    name="addressLine1"
                                    placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                  />
                                  <ErrorMessage
                                    name="addressLine1"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              <div className="mb-3 row">
                                <Label
                                  htmlFor="addressLine2"
                                  className="col-md-2 col-form-label"
                                >
                                  <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 2")}
                                  </h5>
                                </Label>
                                <div className="col-md-10">
                                  <Field
                                    className={
                                      "form-control fs-5" +
                                      (errors.addressLine2 &&
                                      touched.addressLine2
                                        ? " is-invalid"
                                        : "")
                                    }
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                    type="text"
                                    name="addressLine2"
                                    placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                  />
                                  <ErrorMessage
                                    name="addressLine2"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                              </div>
                              {this.state.factoryType === "2" && (
                                <>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="id"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Factory Code")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5 text-uppercase" +
                                          (errors.id && touched.id
                                            ? " is-invalid"
                                            : "")
                                        }
                                        readOnly={true}
                                        type="text"
                                        name="id"
                                        value={this.state.id}
                                        placeholder="xxx0125fgtr"
                                      />
                                      <ErrorMessage
                                        name="id"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="companyName"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t('Company Name')}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.companyName &&
                                          touched.companyName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="companyName"
                                        placeholder="XYZ Diamond"
                                      />
                                      <ErrorMessage
                                        name="companyName"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="gstNo"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("GST No.")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.gstNo && touched.gstNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="gstNo"
                                        placeholder="04AABCU9603R1ZV"
                                      />
                                      <ErrorMessage
                                        name="gstNo"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="panNo"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Pan No.")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5 text-uppercase" +
                                          (errors.panNo && touched.panNo
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="panNo"
                                        placeholder="AAECC6548C"
                                      />
                                      <ErrorMessage
                                        name="panNo"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="cinLlpIn"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        CIN / LLP IN
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.cinLlpIn && touched.cinLlpIn
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="cinLlpIn"
                                        placeholder="L01631KA2010PTC096843"
                                      />
                                      <ErrorMessage
                                        name="cinLlpIn"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="tdsRate"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("TDS Rate")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.tdsRate && touched.tdsRate
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="number" onWheel={(e) => e.target.blur()}
                                        name="tdsRate"
                                        placeholder="01%"
                                      />
                                      <ErrorMessage
                                        name="tdsRate"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="city"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                      {this.props.t('City')} 
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.city && touched.city
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="city"
                                        placeholder="City"
                                      />
                                      <ErrorMessage
                                        name="city"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="state"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                      {this.props.t('State')}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          `form-control ${this.state.props.isView == true ? "" : "form-select"} fs-5` +
                                          (errors.state && touched.state
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        name="state"
                                        as="select"
                                      >
                                        <option value="" disabled>
                                          select
                                        </option>
                                        <option name="1" value="1">
                                          Gujarat
                                        </option>
                                        <option name="2" value="2">
                                          Maharashtra
                                        </option>
                                        <option name="3" value="3">
                                          Tamil Nadu
                                        </option>
                                        <option name="4" value="4">
                                          Uttar Pradesh
                                        </option>
                                        <option name="5" value="5">
                                          West Bengal
                                        </option>
                                        <option name="6" value="6">
                                          Karnataka
                                        </option>
                                        <option name="7" value="7">
                                          Rajasthan
                                        </option>
                                        <option name="8" value="8">
                                          Andhra Pradesh
                                        </option>
                                        <option name="9" value="9">
                                          Madhya Pradesh
                                        </option>
                                      </Field>
                                      <ErrorMessage
                                        name="state"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="zipCode"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Zip Code")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.zipCode && touched.zipCode
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="number" onWheel={(e) => e.target.blur()}
                                        name="zipCode"
                                        placeholder="Zip code"
                                      />
                                      <ErrorMessage
                                        name="zipCode"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <div className="col-md-6 col-12">
                                      <div className="row">
                                        <div className="col-md-4">
                                          <Label
                                            htmlFor="cvdRate"
                                            className="col-form-label"
                                          >
                                            <h5 className="text-secondary fw-bold">
                                              {this.props.t("CVD Rate")}
                                            </h5>
                                          </Label>
                                        </div>
                                        <div className="col-md-8">
                                          <Field
                                            className={
                                              "form-control fs-5" +
                                              (errors.cvdRate && touched.cvdRate
                                                ? " is-invalid"
                                                : "")
                                            }
                                            disabled={
                                              this.state.props.isView
                                                ? true
                                                : false
                                            }
                                            type="number" onWheel={(e) => e.target.blur()}
                                            name="cvdRate"
                                            placeholder="Different Rate"
                                          />
                                          <ErrorMessage
                                            name="cvdRate"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-12">
                                      <div className="row">
                                        <div className="col-md-4 text-start text-lg-center">
                                          <Label
                                            htmlFor="lphtRate"
                                            className="col-form-label"
                                          >
                                            <h5 className="text-secondary fw-bold">
                                              {this.props.t("LPHT Rate")}
                                            </h5>
                                          </Label>
                                        </div>
                                        <div className="col-md-8">
                                          <Field
                                            className={
                                              "form-control fs-5" +
                                              (errors.lphtRate &&
                                              touched.lphtRate
                                                ? " is-invalid"
                                                : "")
                                            }
                                            disabled={
                                              this.state.props.isView
                                                ? true
                                                : false
                                            }
                                            type="number" onWheel={(e) => e.target.blur()}
                                            name="lphtRate"
                                            placeholder="Different Rate"
                                          />
                                          <ErrorMessage
                                            name="lphtRate"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <div className="col-md-6 col-12">
                                      <div className="row">
                                        <div className="col-md-4">
                                          <Label
                                            htmlFor="realRate"
                                            className="col-form-label"
                                          >
                                            <h5 className="text-secondary fw-bold">
                                              {this.props.t("REAL Rate")}
                                            </h5>
                                          </Label>
                                        </div>
                                        <div className="col-md-8">
                                          <Field
                                            className={
                                              "form-control fs-5" +
                                              (errors.realRate &&
                                              touched.realRate
                                                ? " is-invalid"
                                                : "")
                                            }
                                            disabled={
                                              this.state.props.isView
                                                ? true
                                                : false
                                            }
                                            type="number" onWheel={(e) => e.target.blur()}
                                            name="realRate"
                                            placeholder="Different Rate"
                                          />
                                          <ErrorMessage
                                            name="realRate"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-6 col-12">
                                      <div className="row">
                                        <div className="col-md-4 text-start text-lg-center">
                                          <Label
                                            htmlFor="jiramRate"
                                            className="col-form-label"
                                          >
                                            <h5 className="text-secondary fw-bold">
                                              {this.props.t("JIRAM Rate")}
                                            </h5>
                                          </Label>
                                        </div>
                                        <div className="col-md-8">
                                          <Field
                                            className={
                                              "form-control fs-5" +
                                              (errors.jiramRate &&
                                              touched.jiramRate
                                                ? " is-invalid"
                                                : "")
                                            }
                                            disabled={
                                              this.state.props.isView
                                                ? true
                                                : false
                                            }
                                            type="number" onWheel={(e) => e.target.blur()}
                                            name="jiramRate"
                                            placeholder="Different Rate"
                                          />
                                          <ErrorMessage
                                            name="jiramRate"
                                            component="div"
                                            className="invalid-feedback"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="mobileNo1"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                      {this.props.t('Mobile no.1')}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.mobileNo1 && touched.mobileNo1
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="number" onWheel={(e) => e.target.blur()}
                                        name="mobileNo1"
                                        placeholder="+91 (132)(564)(9872)"
                                      />
                                      <ErrorMessage
                                        name="mobileNo1"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="mobileNo2"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                      {this.props.t('Mobile no.2')}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.mobileNo2 && touched.mobileNo2
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="number" onWheel={(e) => e.target.blur()}
                                        name="mobileNo2"
                                        placeholder="+91 (132)(564)(9872)"
                                      />
                                      <ErrorMessage
                                        name="mobileNo2"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="email"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                      {this.props.t('Email')}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.email && touched.email
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="email"
                                        name="email"
                                        placeholder="Enter a valid Email ID"
                                      />
                                      <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="shortName"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Short Name")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.shortName && touched.shortName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="shortName"
                                        placeholder="P3Y"
                                      />
                                      <ErrorMessage
                                        name="shortName"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="since"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                        {this.props.t("Since")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.since && touched.since
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="number" onWheel={(e) => e.target.blur()}
                                        name="since"
                                        placeholder="2001"
                                      />
                                      <ErrorMessage
                                        name="since"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="tagLine"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">
                                      {this.props.t("Tagline")}
                                      </h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.tagLine && touched.tagLine
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="tagLine"
                                        placeholder="#Tagline"
                                      />
                                      <ErrorMessage
                                        name="tagLine"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                  <div className="mb-3 row">
                                    <Label
                                      htmlFor="adminNotes"
                                      className="col-md-2 col-form-label"
                                    >
                                      <h5 className="text-secondary fw-bold">{this.props.t("Admin Notes")}</h5>
                                    </Label>
                                    <div className="col-md-10">
                                      <Field
                                        className={
                                          "form-control fs-5" +
                                          (errors.adminNotes &&
                                          touched.adminNotes
                                            ? " is-invalid"
                                            : "")
                                        }
                                        disabled={
                                          this.state.props.isView ? true : false
                                        }
                                        type="text"
                                        name="adminNotes"
                                        as="textarea"
                                        rows="5"
                                      />
                                      <ErrorMessage
                                        name="adminNotes"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </div>
                                  </div>
                                </>
                              )}
                              <div className="col-md-12 text-end">
                                {this.state.props.isView ? (
                                  <Link to="/organization-partyList">
                                    <Button
                                      color="primary"
                                      className="fs-4 px-5"
                                    >
                                      Back
                                    </Button>
                                  </Link>
                                ) : (
                                  <Button
                                    color="primary"
                                    className="fs-4 px-5"
                                    type="submit"
                                    onClick={() => {
                                      if (this.state.props.isEdit == false) {
                                        if (isValid) {
                                          this.handleSubmit(event, values);
                                        }
                                      } else {
                                        this.handleSubmit(event, values);
                                      }
                                    }}
                                  >
                                    Submit
                                  </Button>
                                )}
                              </div>
                            </Row>
                          </Form>
                        )}
                      </Formik>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(AddExternalUnit);
